module.exports = __webpack_public_path__ + "static/media/forward_normal_grey.802499f3.svg";